import script from "./Gamelist.vue?vue&type=script&setup=true&lang=js"
export * from "./Gamelist.vue?vue&type=script&setup=true&lang=js"

import "./game.css?vue&type=style&index=0&id=03bafbee&scoped=true&lang=css"

import exportComponent from "D:\\work\\gw-sh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03bafbee"]])

export default __exports__